/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";

export const IconsCalendar1 = ({ color = "white", className }) => {
  return (
    <svg
      className={`icons-calendar-1 ${className}`}
      fill="none"
      height="20"
      viewBox="0 0 21 20"
      width="21"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="path"
        d="M6.7963 9.33325H8.27778V10.6666H6.7963V9.33325ZM6.7963 11.9999H8.27778V13.3333H6.7963V11.9999ZM9.75926 9.33325H11.2407V10.6666H9.75926V9.33325ZM9.75926 11.9999H11.2407V13.3333H9.75926V11.9999ZM12.7222 9.33325H14.2037V10.6666H12.7222V9.33325ZM12.7222 11.9999H14.2037V13.3333H12.7222V11.9999Z"
        fill={color}
      />

      <path
        className="path"
        d="M5.31481 16.6666H15.6852C16.5022 16.6666 17.1667 16.0686 17.1667 15.3333V5.99992C17.1667 5.26459 16.5022 4.66659 15.6852 4.66659H14.2037V3.33325H12.7222V4.66659H8.27777V3.33325H6.79629V4.66659H5.31481C4.49777 4.66659 3.83333 5.26459 3.83333 5.99992V15.3333C3.83333 16.0686 4.49777 16.6666 5.31481 16.6666ZM15.6852 7.33325L15.6859 15.3333H5.31481V7.33325H15.6852Z"
        fill={color}
      />
    </svg>
  );
};

IconsCalendar1.propTypes = {
  color: PropTypes.string,
};
